import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const HeroSection = () => {
  return (
    <section 
      className="py-20 px-4 bg-gradient-to-r from-blue-50/90 to-indigo-50/90 relative"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50/95 to-indigo-50/95" />
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h1 className="text-4xl font-bold mb-6 text-gray-900">
          PPC Marketing Services
        </h1>
        <p className="text-lg text-gray-700 leading-relaxed mb-8">
          In the fast-paced digital landscape, every click matters. Our PPC services are designed to maximize your online visibility and deliver high-converting traffic straight to your business. By leveraging AI-driven automation and smart optimization tools, we ensure precise targeting, efficient campaign management, and continuous performance improvement. With tailored strategies and intelligent insights, we make sure your ad spend works smarter to generate the best possible ROI.
        </p>
        <div className="flex justify-center">
          <Link to="/demo">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white">
              Schedule a Free Demo
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};